import { BRANDING } from "@/config/branding";
import { APP_VERSION } from "@/lib/version";

export default function LoginFooter() {
  return (
    <p className="mt-8 text-sm text-white/50">
      &copy; {new Date().getFullYear()} {BRANDING.companyName}. All rights reserved.
      <span className="ml-2 text-white/30">v{APP_VERSION}</span>
    </p>
  );
}
